import { Attributes } from "../../shared/types/attributes.type";

export enum OccupationFilterType {
  NO_FILTER = "0",
  PER_PERSON = "1",
  FOR_ADULTS_CHILDREN = "2",
  FOR_ADULTS_CHILDREN_BABIES = "3",
  FOR_ADULTS_TEENS_CHILDREN = "5",
  FOR_ADULTS_TEENS_CHILDREN_BABIES = "7",
  FOR_SENIORS_ADULTS_TEENS_CHILDREN_BABIES = "8",
}

export enum OccupationType {
  OCCUPANCY_TYPE = "OCCUPANCY_TYPE",
  PAX_TYPE = "PAX_TYPE",
}

export enum BaseAccommodationType {
  PAX_TYPE = "PAX_TYPE",
  ADULTS_TYPE = "ADULTS_TYPE",
}

export type OccupancyProps = Attributes<OccupancyEntity>;

export class OccupancyEntity {
  private constructor(
    readonly occupationType: OccupationType,
    readonly occupationFilterType: OccupationFilterType,
    readonly minChildrenAge: number | null,
    readonly maxChildrenAge: number | null,
    readonly minBabiesAge: number | null,
    readonly maxTeensAge: number | null,
    readonly maxSeniorsAge: number | null,
    readonly filterByAge: boolean,
    readonly baseAccommodationType: BaseAccommodationType
  ) {}

  static of(props: OccupancyProps) {
    return new OccupancyEntity(
      props.occupationType,
      props.occupationFilterType,
      props.minChildrenAge,
      props.maxChildrenAge,
      props.minBabiesAge,
      props.maxTeensAge,
      props.maxSeniorsAge,
      props.filterByAge,
      props.baseAccommodationType
    );
  }
}
